const data = {
    projects: [
        {
            id: 1,
            name: "Tclasher",
            image: "/images/clashUI.png",
            gitLink: "#",
            link: "#",
            skills: "Html, CSS, JS"
        },
        {
            id: 2,
            name: "Control Pannel",
            image: "/images/clashCP.png",
            gitLink: "#",
            link: "#",
            skills: "Html, CSS, JS, React Js"
        },
        {
            id: 3,
            name: "Guess My Number",
            image: "/images/guessMyNumber.png",
            gitLink: "https://github.com/jawid-fakhari/guess-my-number.git",
            link: "https://guess-my-number-five-ochre.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 4,
            name: "Pig Game",
            image: "/images/pigGame.png",
            gitLink: "https://github.com/jawid-fakhari/pig-Game.git",
            link: "https://pig-game-phi-nine.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 5,
            name: "Bank App",
            image: "/images/bankistAccount.png",
            gitLink: "https://github.com/jawid-fakhari/Bankist.git",
            link: "https://bankist-sooty.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 6,
            name: "UI Bank App",
            image: "/images/bankistWebsite.png",
            gitLink: "https://github.com/jawid-fakhari/bankist-second-project.git",
            link: "https://bankist-second-project.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 7,
            name: "Mapty App",
            image: "/images/mapty.png",
            gitLink: "https://github.com/jawid-fakhari/starter.git",
            link: "https://mapty-sigma.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 8,
            name: "Crowdfunding product page",
            image: "./images/crowdfund.png",
            gitLink: "https://github.com/jawid-fakhari/crowdfunding-product-page-main.git",
            link: "https://crowdfunding-product-page-main-two.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 9,
            name: "Tip Calculator",
            image: "/images/splitter.png",
            gitLink: "https://github.com/jawid-fakhari/15.tip-calculator-app-main-junior-.git",
            link: "https://tip-calculator-app-xi.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 11,
            name: "Weather App",
            image: "/images/weatherApp.png",
            gitLink: "https://github.com/jawid-fakhari/weather-app.git",
            link: "https://weather-app-ashen-one.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 12,
            name: "To Do List",
            image: "/images/toDoList.png",
            gitLink: "https://github.com/jawid-fakhari/to-do-list-app.git",
            link: "https://to-do-list-app-lyart-mu.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 13,
            name: "Simpple Quiz",
            image: "/images/simpleQuiz.png",
            gitLink: "https://github.com/jawid-fakhari/Quiz-App.git",
            link: "https://quiz-app-lilac-kappa.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 14,
            name: "Password Maker App",
            image: "./images/passwordGenrator.png",
            gitLink: "https://github.com/jawid-fakhari/password-maker-app.git",
            link: "https://password-maker-app.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 15,
            name: "Base Apparel coming soon page",
            image: "./images/comingSoon.png",
            gitLink: "https://github.com/jawid-fakhari/base-apparel-coming-soon-master.git",
            link: "https://base-apparel-coming-soon-master-beta-seven.vercel.app/",
            skills: "Html, CSS, JS"
        },
        {
            id: 21,
            name: "Intro component with sign-up form",
            image: "/images/signup2.png",
            gitLink: "https://github.com/jawid-fakhari/intro-component-with-signup-form-master.git",
            link: "https://intro-componen-git-master-jawid-2ffa19.vercel.app/",
            skills: "Html, CSS, JS"
        },
    ],
    about: {
        image: "/images/jobSeeker.png"
    },
    logo: {
        positive: "/images/my-logo-positive.png",
        negative: "/images/my-logo-negative.png",
    }
}
export default data;